import React from 'react';
import { BsPersonFill, BsFillPenFill, BsFillBookFill } from 'react-icons/bs';
import { AiFillPhone, AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';
import { GiEarthAfricaEurope } from 'react-icons/gi';
import { MdSportsEsports } from 'react-icons/md';
import img from '../../../Assets/aisha-ahmad.jpg'
import './About.css'
import { FiFacebook, FiGithub, FiInstagram, FiLinkedin } from 'react-icons/fi';

const About = () => {
    return (
        <div className='mb-24 px-5 w-screen md:max-w-[760px] lg:max-w-[1075px] md:mx-auto lg:w-full' id='about'>
            <div className='text-3xl md:text-5xl flex '>
                <h3 className='numbered-heading mt-10 lg:mt-0 mb-3 lg:mb-0 font-bold md:text-4xl heading-style' data-aos="fade-up">About Me</h3>
            </div>
            <div className='flex flex-col-reverse md:flex-row '>
                <div className='w-full md:w-7/12 lg:w-9/12 mt-0 md:mt-10' >
                    <p className='mb-5 text-lg md:text-lg leading-6 text-gray-500' data-aos="fade-up">Howdy! My name is Aisha. I'm a front-end developer. My first interest in coding came from reading chapter 4 (on web development) of an information technology book in high school. After finishing high school I focused on learning programming and entered the coding world. And that's how you know me...</p>
                    {/* <p className='mb-5 text-lg md:text-lg leading-6 text-gray-500'>
                        I'm a humanities background student who loves technology and science. Although my academic study background is not related to programming, I believe curiosity, dedication, and passion will take me far in the world of technology inshallah.</p> */}
                    <p className='mb-5 text-lg md:text-lg leading-6 text-gray-500' cdata-aos="fade-up">
                        I've done several projects from scratch and keep learning new things daily. Also, trying to get professional experience in front-end development. Currently, I'm working on Tegra design located in Arlington, Virginia.</p>
                    <div>


                        {/* <table className='my-8 text-lg'>
                            <tr>
                                <th className='pr-5 md:pr-10 flex items-center '><BsPersonFill className='mr-2 text-2xl text-gray-800' />Name</th>
                                <td className='pr-5 md:pr-10'>:</td>
                                <td>Syeda Aisha Ahmad</td>
                            </tr>
                            <tr>
                                <th className='pr-5 md:pr-10 flex items-center'> <AiFillPhone className='mr-2 text-2xl text-gray-800' /> Phone</th>
                                <td>:</td>
                                <td>+8801992756161</td>
                            </tr>
                            <tr>
                                <th className='pr-5 md:pr-10 flex items-center'> <AiOutlineMail className='mr-2 text-2xl text-gray-800' /> Email</th>
                                <td>:</td>
                                <td>19aishaahmad@gmail.com</td>
                            </tr>
                        </table> */}
                        {/* <h3 className='text-2xl font-semibold mb-3 '>My Interests</h3>
                        <div className='flex justify-start md:justify-between w-7/12'>
                            <span className='pr-10 flex items-center'> <BsFillPenFill className='mr-2 text-2xl text-gray-800' /> Writing</span>
                            <span className='pr-10 flex items-center'> <BsFillBookFill className='mr-2 text-2xl text-gray-800' /> Book</span>
                            <span className='pr-10 flex items-center'> <GiEarthAfricaEurope className='mr-2 text-2xl text-gray-800' /> Travel</span>
                        </div> */}



                        <div className='flex justify-between md:w-10/12 lg:w-7/12 mt-10' data-aos="fade-up">
                            <div className='text-center'>
                                <h3 className='text-3xl font-bold text-primary mb-2'>01+</h3>
                                <p className='font-medium'>Years
                                    <br />
                                    experience
                                </p>
                            </div>

                            <div className='text-center'>
                                <h3 className='text-3xl font-bold text-primary mb-2'>10+</h3>
                                <p className='font-medium'>Completed
                                    <br />
                                    projects
                                </p>
                            </div>

                            <div className='text-center'>
                                <h3 className='text-3xl font-bold text-primary mb-2'>01+</h3>
                                <p className='font-medium'>Companies
                                    <br />
                                    worked
                                </p>
                            </div>
                        </div>

                        <div className='md:hidden' data-aos="fade-up">
                            <ul className='flex justify-center gap-10 text-2xl items-center text-sky-600 mt-10'>
                                <li className='mb-5'> <a href="https://github.com/Syeda-Aisha-Ahmad" target="_blank" rel="noreferrer"> <FiGithub /> </a> </li>

                                <li className='mb-5'> <a href="https://www.linkedin.com/in/aisha-ahmad19/" target="_blank" rel="noreferrer"> <FiLinkedin /> </a> </li>

                                {/* <li className='mb-5'> <a href=""> <FiTwitter /> </a> </li> */}


                                <li className='mb-5 text-3xl'> <a href="tel:123-456-7890"><AiOutlinePhone /></a> </li>

                                <li className='mb-5'> <a href="https://www.instagram.com/18aishaahmad/" target="_blank" rel="noreferrer"> <FiInstagram /> </a> </li>

                                <li className='mb-5'> <a href="https://www.facebook.com/profile.php?id=100015597035398" target="_blank" rel="noreferrer"> <FiFacebook /> </a> </li>
                            </ul>
                        </div>

                    </div>
                </div>

                <div className='w-full mt-12 md:mt-20 lg:mt-0 md:w-5/12 lg:4/12' data-aos="fade-up">
                    <img className='relative bottom-10 w-full md:w-full lg:w-10/12 mx-auto mt-5 md:mt-0 md:ml-4 lg:ml-20' src={img} alt="" />
                </div>
            </div>


        </div >

    );
};

export default About;